<template>
  <div id="forecast-view" class="relative overflow-hidden">
    <component :is="scrollbarTag" class="scroll-area-location-content" :settings="settings">   
      <div class="vx-row">
        <div class="vx-col w-full mb-base" >
          <vx-card  ref="contentCard" :title="$t('GradeControl.ProductionSummary.GradePerPeriod')" class="mb-8" title-color="black" refresh-content-action @refresh="getForecastStats">
            <vs-row vs-type="flex" vs-justify="space-between">
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="8" class="m-3">
                <div class="vx-row mb-base w-full">
                  <div class="vx-col w-full md:w-1/2" >
                    <form-label>{{$t('GradeControl.Forecast.ForecastList')}}</form-label>
                    <forecast-selection @valueChanged="onPeriodChanged"></forecast-selection>
                  </div>
                  <div class="vx-col w-full md:w-1/2 " >
                    <form-label>{{$t('GradeCalculation.Name')}}</form-label>
                    <v-select
                      label="name"
                      :options="gradeCalculation"
                      :reduce="calc => calc.id"
                      v-model="selectedCalculation"
                      class="w-full"
                      name="calculationId"
                    />
                  </div>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="3" class="m-3" >
                <vs-switch color="success" icon-pack="feather" vs-icon-on="icon-list" vs-icon-off="icon-bar-chart" v-model="isList">
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vs-col>
            </vs-row>
            <div v-show="!selectedPeriod"  style="padding-bottom:300px;">
            </div>
            <GradeBoxPlot  v-show="selectedPeriod && !isList" ref="gradeBoxPlot"
              :title="$t('GradeControl.MonthlySummary.GradeDistribution')"
              @onLocationSelected="selectLocation"
              :gradeCalculationType="selectedCalculation">
            </GradeBoxPlot>
            <location-stats-grid  v-show="selectedPeriod && isList"
              ref="locationStatsGrid"
              @onSelectLocationForecast="selectLocationForecast"
              :gradeCalculationType="selectedCalculation">
            </location-stats-grid>
          </vx-card>
        </div>  
      </div>
    </component>
    <forecast-location-view
        :displayList="isList"
        :openLocationForecast = "selectedLocationForecast"
        :isSidebarActive = "isSidebarActive"
        :gradeCalculationType="selectedCalculation"
        @previousLocation = "previousLocation"
        @nextLocation = "nextLocation"
        @closeSidebar  = "closeLocationSidebar"
        @onLocationForecastUpdated = "getForecastStats">
    </forecast-location-view>
  </div>
</template>
<script>

import vSelect from 'vue-select';
import { DateCell, ErrorBoundary, FormLabel } from "../../../shared/components";
import Datepicker from 'vuejs-datepicker';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import LocationStatsGrid from "./components/LocationStatsGrid";
import moduleGradeControl from "@/store/geo/gradecontrol/moduleGradeControl.js";
import GradeCalculationTypeEnum from "./../GradeCalculationTypeEnum.js"
import GradeBoxPlot from "./components/GradeBoxPlot.vue"
import SampleListGrid from "./components/SampleListGrid"
import SamplesScatter from "./components/SamplesScatter.vue"
import ForecastLocationView from "./components/ForecastLocationView.vue"
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ForecastSelection from "./../components/ForecastSelection.vue"

export default {
  components: {
    vSelect,
    DateCell,
    ErrorBoundary,
    Datepicker,
    FormLabel,
    LocationStatsGrid,
    StatisticsCardLine,
    GradeBoxPlot,
    SampleListGrid,
    SamplesScatter,
    ForecastLocationView,
    VuePerfectScrollbar,
    ForecastSelection
  },
  data() {
    return {
      selectedPeriod: null,
      selectedProjectId: null,
      selectedCalculation: GradeCalculationTypeEnum.SampleOnly,
      selectedLocationForecast: null,
      gradeCalculation: [],
      postedLocations: null,
      isList: false,
      isSidebarActive : false,
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      }
    };
  },
  computed: {
    statsList() {
      return this.$store.state.gradeControl.forecastStatsList;
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  watch: {
    selectedCalculation() {
      this.$refs.contentCard.refreshcard();
    },
    selectedStartDate(val) {
      if (!val) return;

      if (this.selectedEndDate === null) {

        const d = new Date(val.valueOf())
        d.setMonth(d.getMonth() + 1);
        if (d.getDate() !== d) {
          d.setDate(0);
        }

        this.selectedEndDate = d;
      } 
      else {
        this.$refs.contentCard.refreshcard()
      }
    },
    selectedEndDate(val) {
      if (!val) return;

      this.$refs.contentCard.refreshcard()
    }
  },
  mounted() {
    this.$store.dispatch("gradeControl/clearMuckListItems");
  },
  created() {
    if (!moduleGradeControl.isRegistered) {
      this.$store.registerModule("gradeControl", moduleGradeControl);
      moduleGradeControl.isRegistered = true;
    }

    this.gradeCalculation = [
      { id:GradeCalculationTypeEnum.SampleOnly, name:this.$t("GradeCalculation." + GradeCalculationTypeEnum.SampleOnly) },
      { id:GradeCalculationTypeEnum.SampleOnlyCapped, name:this.$t("GradeCalculation." + GradeCalculationTypeEnum.SampleOnlyCapped) }
    ];

    this.selectedProjectId = Number(this.$store.state.projectId);
  },
  methods: {
    onPeriodChanged(val) {
      this.selectedPeriod = val;
      this.$refs.contentCard.refreshcard();
    },
    selectLocation(locationCode) {
      const location =  this.$store.state.gradeControl.forecastStatsList.find(f => f.locationCode === locationCode);
      if (location)
        this.selectLocationForecast(location)
    },
    getForecastStats() {
      if (this.selectedPeriod && this.selectedProjectId) {
        this.$refs.locationStatsGrid.fetchStats(this.selectedProjectId, this.selectedPeriod.startDate, this.selectedPeriod.endDate).then(() => { 
          this.$refs.gradeBoxPlot.affectAttributes(this.$store.state.gradeControl.forecastStatsList);
          this.$refs.contentCard.removeRefreshAnimation();
        });
      }
      else {
        this.$refs.contentCard.removeRefreshAnimation()
      }
    },
    selectLocationForecast(val) {
      this.selectedLocationForecast = val;
      this.isSidebarActive = true
    },
    getSamples() {
      if (this.selectedLocationForecast) {
        this.$refs.sampleListGrid.getSamplesList(this.selectedLocationForecast.locationForecastId).then(() => { 
          this.$refs.sampleListCard.removeRefreshAnimation();
          this.$refs.locationGradeBoxPlot.affectAttributes([this.selectedLocationForecast]);
          this.$refs.sampleScatter.defineDiagramSettings();
        });
      }
    },
    nextLocation () {
      const currentLocationIndex = this.statsList.findIndex((f) => f.locationForecastId === this.selectedLocationForecast.locationForecastId)
      if (this.statsList[currentLocationIndex + 1]) this.selectedLocationForecast = this.statsList[currentLocationIndex + 1];
    },
    previousLocation () {
      const currentLocationIndex = this.statsList.findIndex((f) => f.locationForecastId === this.selectedLocationForecast.locationForecastId)
      if (this.statsList[currentLocationIndex - 1]) this.selectedLocationForecast = this.statsList[currentLocationIndex + 1];
    },
    closeLocationSidebar () {
      this.isSidebarActive = false
    }
  }
};
</script>
<style lang="scss">
#forecast-view {
  .vs-sidebar--background {
    position: absolute;
  }
  .full-vs-sidebar {
    .vs-sidebar {
      max-width: 100%;
    }
  }

  .con-vs-popup {
    .vs-popup {
      width: 1200px !important;
      height: auto !important;
    }
  } 

  .select-all-chexkbox{
      .vs-checkbox{
          margin-right: 0.8rem;
      }
  }

  .location-content-scroll-area {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 100px);

      &:not(.ps) {
        overflow-y: auto;
      }
  }

  .scroll-area-location-content {
    position: relative;
    margin: auto;
    width: 100%;
    height: calc(100% - 6.3%);

    &:not(.ps) {
      overflow-y: auto;
    }
  }

  .location-view-sidebar {
    .vs-sidebar{
        background-color: #f8f8f8 !important;
        border-left: 1px solid #dae1e7;
    }

    .location-header{
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
        border-bottom: 1px solid #eee;
        z-index: 1;
        position: relative;
    }

    .mail__attachment {
      .vs-chip--text {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
  
  .list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }

  
}

</style>
